module.exports = __webpack_public_path__ + "img/banner-princiapal.cc1ca193.png";